(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["motion"] && !Shopify.designMode) return;
  try {
    (function () {
    const root = document.documentElement;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    // ---- scroll reveals -------------------------------------------------
    if ('IntersectionObserver' in window && !reduced.matches) {
      const targets = document.querySelectorAll('.reveal');
      if (targets.length) {
        root.classList.add('motion-ready');

        const reveal = (el) => el.classList.add('is-in');

        /*
         * Failsafe for anything already on screen that the observer did not
         * reveal. It deliberately does NOT touch elements below the fold —
         * those are meant to wait — and it is not cancelled by the observer
         * firing, because the observer's first callback runs immediately for
         * off-screen targets too and would cancel the guard before it helped.
         */
        setTimeout(() => {
          targets.forEach((el) => {
            const box = el.getBoundingClientRect();
            if (box.top < window.innerHeight && box.bottom > 0) reveal(el);
          });
        }, 1800);

        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              reveal(entry.target);
              io.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
        );

        targets.forEach((el) => io.observe(el));
      }
    }

    // ---- scrolled header ------------------------------------------------
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        root.classList.toggle('is-scrolled', window.scrollY > 8);
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-input"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-quantity-down], [data-quantity-up]');
    if (!step) return;

    const wrapper = step.closest('[data-quantity]');
    const input = wrapper && wrapper.querySelector('[data-quantity-input]');
    if (!input) return;

    const min = Number(input.min || 0);
    const next = Number(input.value || 0) + (step.hasAttribute('data-quantity-up') ? 1 : -1);
    input.value = String(Math.max(min, next));

    // Let the form decide what to do, exactly as if the value had been typed.
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  } catch(e) { console.error(e); }
})();

})();
